import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Tab, type TabProps, Tabs } from '@shared/ui';
import type { FC, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

export type CoachProfileTab = 'overview' | 'calendar';

const RouteTab = Tab as FC<TabProps & { href: string }>;

interface CoachProfileNavigationProps {
  coachId: string;
  activeTab: CoachProfileTab;
}

export default function CoachProfileNavigation({
  coachId,
  activeTab,
}: CoachProfileNavigationProps) {
  const navigate = useNavigate();
  const encodedCoachId = encodeURIComponent(coachId);
  const overviewPath = `/admin/coaches/${encodedCoachId}`;
  const calendarPath = `${overviewPath}/calendar`;

  const navigateWithoutReload = (path: string) => (event: MouseEvent<HTMLElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    navigate(path);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/admin/coaches')}
        sx={{ mb: 2 }}
      >
        Back to Coaches
      </Button>
      <Tabs value={activeTab} aria-label="Coach profile sections">
        <RouteTab
          label="Overview"
          value="overview"
          href={overviewPath}
          onClick={navigateWithoutReload(overviewPath)}
        />
        <RouteTab
          label="Calendar"
          value="calendar"
          href={calendarPath}
          onClick={navigateWithoutReload(calendarPath)}
        />
      </Tabs>
    </Box>
  );
}
